class optionDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#OptionsDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.selectedOptions = new Map();
    this.initDrawer();
    this.optionDropdown();
  }

  initDrawer() {
    this.add = document.querySelectorAll('[js-options-drawer="add"]');
    this.apply = document.querySelectorAll('[js-options-drawer="apply"]');
    this.optionsButton = document.querySelectorAll('[js-options-drawer="button"]');
    this.options = document.querySelectorAll('[js-options-drawer="options"]');
    this.discard = document.querySelectorAll('[js-options-drawer="discard"]');
    this.inputNameValue = document.querySelectorAll('[js-option-drawer="option"]');
    this.birthstoneSelectionIds = document.querySelectorAll('[js-option-drawer="selection-uuids"]');
    this.addDefaultPlaceholder = '[js-options-drawer="default-placeholder"]';
    this.addSelectedPlaceholder = '[js-options-drawer="selection-placeholder"]';
    this.drawerTextProps = document.querySelectorAll('[js-options-drawer="text-option"]');
    this.drawerInner = document.querySelectorAll('[js-options-drawer="inner"]');
    this.textFields = document.querySelectorAll('[js-options-drawer="text"]');
    this.allDrawersButton = Array.from(this.add)
      .map((button) => button.getAttribute('name'))
      .filter(Boolean);
    this.allDrawersButton.forEach((drawer) => this.selectedOptions.set(drawer, false));

    this.add.forEach((button) => this.openDrawer(button));
    this.discard.forEach((button) => button.addEventListener('click', () => this.discardChanges(button)));
    this.apply.forEach((button) => button.addEventListener('click', () => this.applyBirthstone()));
    document.addEventListener(
      'click',
      function (event) {
        const clickedOutsideButtons = !Array.from(this.optionsButton).some((button) => button.contains(event.target));
        const clickedOutsideOptions = !Array.from(this.options).some((option) => option.contains(event.target));

        if (clickedOutsideButtons && clickedOutsideOptions) {
          this.options.forEach((option) => {
            option.style.display = 'none';
            const associatedButton = option
              .closest('.options-drawer__field')
              .querySelector('[js-options-drawer="button"]');

            if (associatedButton) {
              associatedButton.classList.remove('is-active');
            }
          });
        }
      }.bind(this)
    );
    this.textCounter();
  }

  openDrawer(button) {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(button);
    });
    button.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(button);
      }
    });
  }

  open(triggeredBy) {
    if (!triggeredBy) return;
    this.drawerInner.forEach((drawer) => {
      drawer.classList.toggle('hidden', drawer.dataset.name !== triggeredBy.getAttribute('name'));
      if (drawer.dataset.name === triggeredBy.getAttribute('name')) {
        this.setActiveElement(triggeredBy, drawer);
      }
    });

    // Apply animations after a slight delay to ensure they trigger
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.drawerInner.forEach((drawer) => {
      if (this.activeElement.getAttribute('name') === drawer.dataset.name) {
        drawer.classList.add('hidden');
      }
    });
    this.activeElement = null;
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element, drawer) {
    this.activeElement = element;
    this.activeInnerContainer = drawer;
  }

  optionDropdown() {
    this.optionsButton.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        this.options.forEach((option, i) => {
          if (i !== index) {
            option.style.display = 'none';
            this.optionsButton[i].classList.remove('is-active');
          }
        });

        const isVisible = this.options[index].style.display === 'flex';
        this.options[index].style.display = isVisible ? 'none' : 'flex';
        button.classList.toggle('is-active', !isVisible);
        this.optionListener(this.options[index], button);
      });
    });
  }

  optionListener(optionElement, button) {
    optionElement.querySelectorAll('[js-options-drawer="option-value"]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.updateButtonText(checkbox, button);
      });
    });
  }

  updateButtonText(checkbox, button) {
    if (!checkbox.checked) return;

    button.querySelector('[js-options-drawer="selected-value"]').innerHTML = checkbox.value;
    button.value = checkbox.dataset.birthstoneName;
    button.querySelector('[js-options-drawer="selected-value"]').classList.remove('hidden');
    button.querySelector('[js-options-drawer="button-placeholder"]').classList.add('hidden');
    checkbox.closest('[js-options-drawer="options"]').style.display = 'none';
    if (button.classList.contains('is-active')) {
      button.classList.remove('is-active');
    }

    if (checkbox.hasAttribute('data-birthstone-price')) {
      button.setAttribute('data-birthstone-price', checkbox.dataset.birthstonePrice);
    }

    this.checkApplyButtonState();
    this.checkText();
  }

  checkApplyButtonState() {
    const options = this.activeInnerContainer.querySelectorAll('[js-options-drawer="options"]');
    const hasRequiredGroups = Array.from(options).some((group) =>
      Array.from(group.querySelectorAll('[js-options-drawer="option-value"]')).some((input) =>
        input.hasAttribute('required')
      )
    );
    const allRequiredGroupsSelected = Array.from(options).every((group) => {
      const requiredCheckboxes = group.querySelectorAll('[js-options-drawer="option-value"][required]');

      if (requiredCheckboxes.length === 0) {
        return true;
      }

      return Array.from(requiredCheckboxes).some((input) => input.checked);
    });

    const allRequiredTextInputsFilled = Array.from(
      this.activeInnerContainer.querySelectorAll('[js-options-drawer="text"]')
    ).every((input) => {
      if (input.hasAttribute('required')) {
        return input.value.trim() !== '';
      }
      return true;
    });

    if (
      (hasRequiredGroups && allRequiredGroupsSelected && allRequiredTextInputsFilled) ||
      (!hasRequiredGroups && allRequiredTextInputsFilled)
    ) {
      this.activeInnerContainer.querySelector('[js-options-drawer="apply"]').removeAttribute('disabled');
      return;
    }

    this.activeInnerContainer.querySelector('[js-options-drawer="apply"]').setAttribute('disabled', 'disabled');
  }

  checkText() {
    this.activeInnerContainer.querySelectorAll('[js-options-drawer="text"]')?.forEach((textField) => {
      const counter = textField
        .closest('.options-drawer__field-option-block')
        .querySelector('[js-options-drawer="counter"]');
      textField.addEventListener('input', () => {
        const caretStart = textField.selectionStart;
        const caretEnd = textField.selectionEnd;
        textField.value = textField.value.toUpperCase();
        textField.setSelectionRange(caretStart, caretEnd);
        this.updateCharacterCounter(textField, counter);
        this.checkApplyButtonState();
      });
    });
  }

  discardChanges(button) {
    const activeInnerContainer = button.closest('[js-options-drawer="inner"]');
    if (!activeInnerContainer) return;

    activeInnerContainer
      .querySelectorAll('[js-options-drawer="option-value"]')
      .forEach((option) => (option.checked = false));

    activeInnerContainer.querySelector('[js-options-drawer="apply"]').setAttribute('disabled', 'disabled');

    activeInnerContainer.querySelectorAll('[js-options-drawer="button"]').forEach((button) => {
      const buttonPlaceholder = button.querySelector('[js-options-drawer="button-placeholder"]');

      if (buttonPlaceholder.classList.contains('hidden')) {
        button.querySelector('[js-options-drawer="selected-value"]').classList.add('hidden');
        buttonPlaceholder.classList.remove('hidden');
      }
      button.removeAttribute('data-birthstone-price');
      button.value = '';
    });

    if (this.textFields) {
      activeInnerContainer.querySelectorAll('[js-options-drawer="text"]').forEach((textField) => {
        if (textField.id.startsWith(`_${button.getAttribute('name')}`)) {
          textField.value = '';
        }
        const counter = textField
          .closest('.options-drawer__field-option-block')
          .querySelector('[js-options-drawer="counter"]');
        counter.innerHTML = `0/${textField.getAttribute('maxlength')} ${window.personalisationStrings.characterString}`;
      });
      this.drawerTextProps.forEach((input) => (input.value = ''));
    }

    if (this.activeElement) {
      this.activeElement.querySelector(this.addDefaultPlaceholder).classList.remove('hidden');
      this.activeElement.querySelector(this.addSelectedPlaceholder).innerHTML = '';
      this.activeElement.querySelector(this.addSelectedPlaceholder).classList.add('hidden');
      this.selectedOptions.set(this.activeElement.getAttribute('name'), false);
    } else {
      document.querySelectorAll('[js-options-drawer="default-placeholder"]').forEach((placeholder) => {
        placeholder.classList.remove('hidden');
      });
      document.querySelectorAll('[js-options-drawer="selection-placeholder"]').forEach((placeholder) => {
        placeholder.innerHTML = '';
        placeholder.classList.add('hidden');
      });
    }

    activeInnerContainer.querySelectorAll('[js-birthstone="birthstone-option"]').forEach((input) => (input.value = ''));

    const inputs = [...(this.inputNameValue || []), ...(this.birthstoneSelectionIds || [])];
    inputs.forEach((element) => {
      if (element.id.startsWith(`_${button.getAttribute('name')}`)) {
        element.value = '';
      }
      if (element.hasAttribute('required')) {
        document.querySelector('[js-product-form="add-to-cart"]').setAttribute('disabled', 'disabled');
      }
    });
  }

  applyBirthstone() {
    let selectionCount = 0;
    const selectionIds = [];
    let totalPrice = 0;

    this.activeInnerContainer.querySelectorAll('[js-options-drawer="button"]').forEach((button) => {
      const correspondingNameValue = Array.from(this.inputNameValue).find(
        (value) => value.id === button.getAttribute('js-birthstone-input-id')
      );

      if (button.value && correspondingNameValue) {
        correspondingNameValue.value = button.value;
        selectionCount++;
        selectionIds.push(button.getAttribute('js-birthstone-uuid'));
        const totalBirthstonePrice = parseFloat(button.dataset.birthstonePrice || '0') / 100;
        if (!isNaN(totalBirthstonePrice)) {
          totalPrice += totalBirthstonePrice;
        }
      }
    });

    this.activeInnerContainer.querySelectorAll('[js-options-drawer="text"]')?.forEach((text) => {
      const correspondingTextValues = Array.from(this.drawerTextProps).filter((value) => value.id === text.id);
      if (text.value && correspondingTextValues) {
        correspondingTextValues.forEach((correspondingTextValue) => (correspondingTextValue.value = text.value.toUpperCase()));
      }
    });

    this.activeElement.querySelector(this.addDefaultPlaceholder).classList.add('hidden');
    this.activeElement.querySelector(this.addSelectedPlaceholder).classList.remove('hidden');
    this.birthstoneSelectionIds.forEach((input) => {
      if (this.activeElement.getAttribute('name') === input.dataset.name) {
        input.value = String(selectionIds.join(','));
      }
    });

    let selectionText = `${selectionCount} `;
    selectionText +=
      selectionCount > 1
        ? window.birthstoneStrings.selectionPlaceholderTwo
        : window.birthstoneStrings.selectionPlaceholderOne;

    if (totalPrice > 0) {
      selectionText += ` (+${window.birthstoneStrings.currentCurrencySymbol}${totalPrice.toFixed(2)})`;
    }

    const allRequiredFieldsFilled = Array.from(this.inputNameValue || []).every((element) => {
      return !element.hasAttribute('required') || element.value !== '';
    });
    const addToCartButton = document.querySelector('[js-product-form="add-to-cart"]');
    if (allRequiredFieldsFilled) {
      addToCartButton.removeAttribute('disabled');
    } else {
      addToCartButton.setAttribute('disabled', 'true');
    }

    this.selectedOptions.set(this.activeElement.getAttribute('name'), true);
    this.activeElement.querySelector(this.addSelectedPlaceholder).innerHTML = selectionText;
    this.close();
  }

  updateCharacterCounter(textField, counter) {
    if (!counter) return;
    counter.innerHTML = `${textField.value.length}/${textField.getAttribute('maxlength')} ${window.personalisationStrings.characterString}`;
  }

  textCounter() {
    this.textFields.forEach((textField) => {
      const counter = textField
        .closest('.options-drawer__field-option-block')
        .querySelector('[js-options-drawer="counter"]');
      textField.addEventListener('input', () => {
        this.updateCharacterCounter(textField, counter);
      });
    });
  }
}

customElements.define('options-drawer', optionDrawer);
